module.exports = __webpack_public_path__ + "img/flusher_driving.b676008d.svg";